import React, { useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Navbar from "./components/Navbar";
import BBCodeMenu from "./components/BBCodeMenu";
import SettingsMenu from "./components/SettingsMenu";

function App() {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);

  return (
    <div className="App">
      <header>
        <Navbar setBackdropOpen={setBackdropOpen} setOpenSettings={setOpenSettings} />
        <BBCodeMenu backdropOpen={backdropOpen} setBackdropOpen={setBackdropOpen} />
        <SettingsMenu openSettings={openSettings} setOpenSettings={setOpenSettings} />
      </header>
    </div>
  );
}

export default App;
